import { Asset } from '../..';
import { publicOffersLoadedState } from '../../../../../../../../store/product/atom';
import {
  publicOffersCustomFiltersQuery,
  publicOffersQueryUpdated,
} from '../../../../../../../../store/product/selectors';

import { PublicOfferItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const PublicOfferAsset = () => {
  return (
    <Asset
      productsQuery={publicOffersQueryUpdated}
      customFiltersQuery={publicOffersCustomFiltersQuery}
      ProductItem={PublicOfferItem}
      ProductItemLoading={ListLoadingItem}
      atomToSetProductsLoaded={publicOffersLoadedState}
      keySelector="offerId"
    />
  );
};
